(() => {
  class TreatmentPlanFormController {
    constructor($rootScope, $scope, $timeout, $interval, toastr, $state, ngDialog, Utils, Orders, Notifications) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $rootScope,
        $timeout,
        $interval,
        toastr,
        $state,
        ngDialog,
        Utils,
        Orders,
        Notifications,
        order: $scope.ngDialogData.order
      });
      this.numQuickClicks = 0;
      this.processing = false; // We do this to make the modal "movable or draggable"

      $scope.$on('ngDialog.opened', function (e, $dialog) {
        $(".ngdialog-theme-default.treatment-plan-form-modal").children(".ngdialog-content").draggable({
          handle: ".treatment-plans-popup"
        });
      });
      this.getTreatmentPlans();
    }

    getTreatmentPlans() {
      this.Orders.getTreatmentPlans(this.order.id).then(({
        data
      }) => {
        data.forEach(treatmentPlan => {
          var prescription = this.order.prescriptions.find(x => x.id === treatmentPlan.prescription_id);

          if (prescription && prescription.pharmacy) {
            treatmentPlan.pharmacy = prescription.pharmacy;
          }
        });
        this.treatment_plans = data;
      }).catch(err => this.toastr.error(this.Notifications.generic.failure)); // .finally(() => { this.loading = false; });
    } // close() {
    //   this.$scope.closeThisDialog(null);
    // }


    save() {
      var this2 = this;
      this.numQuickClicks = this.numQuickClicks + 1;
      console.log("Click Number: " + this.numQuickClicks);

      if (this.numQuickClicks === 1) {
        this.saveTreatmentPlans();
      } else {
        this2.$timeout(() => {
          this2.numQuickClicks = 0;
        }, 1000);
      }
    }

    saveTreatmentPlans() {
      var processed = 0;
      var toProcess = this.treatment_plans.length;
      var hasError = false;
      this.processing = true;
      this.treatment_plans.forEach(treatment_plan => {
        this.Orders.saveTreatmentPlans(this.order.id, treatment_plan.prescription_id, treatment_plan.template).then(() => {
          processed += 1;
          this.toastr.success("Treatment plan for " + treatment_plan.medication_name + " sent successfully.");

          if (processed >= toProcess) {
            this.processing = false;

            if (!hasError) {
              var response = {
                success: true
              };
              this.$scope.closeThisDialog(response);
            }
          }
        }).catch(err => {
          hasError = true;
          processed += 1;

          if (err && err.data && err.data.message && err.data.message.summary) {
            this.toastr.error("Error sending treatment plan for " + treatment_plan.medication_name + ': ' + err.data.message.summary);
          } else {
            this.toastr.error("Error sending treatment plan for " + treatment_plan.medication_name + ': ' + this.Notifications.generic.failure);
          }

          if (processed >= toProcess) {
            this.processing = false; // THERE IS AN ERROR
            // SO WE DON'T CLOSE THE POPUP

            /*
            var response = {
              success: true
            }
            this.$scope.closeThisDialog(response);
            */
          }
        }); // .finally(() => { this.loading = false; });
      });
    }

  }

  TreatmentPlanFormController.$inject = ["$rootScope", "$scope", "$timeout", "$interval", "toastr", "$state", "ngDialog", "Utils", "Orders", "Notifications"];
  angular.module('pims').controller('TreatmentPlanFormController', TreatmentPlanFormController);
})();